import type { PapelNoCliente } from "@base/contracts";

export const ROTULO_DO_PAPEL_NO_CLIENTE: Readonly<Record<PapelNoCliente, string>> = {
  gestor: "Gestor",
  membro: "Membro",
};

/** Iniciais do cliente para o "logo" do seletor: "Clínica Sol" -> "CS". */
export function iniciaisDoCliente(nome: string): string {
  const palavras = nome.trim().split(/\s+/).filter(Boolean);
  return palavras
    .slice(0, 2)
    .map((palavra) => palavra[0] ?? "")
    .join("")
    .toUpperCase();
}
